export const CURRENCY_SYMBOLS = {
  GBP: "£",
  USD: "$",
  EUR: "€",
  PKR: "₨",
  Rs: "₨",
};

export const getCurrencySymbol = (currencyCode) =>
  CURRENCY_SYMBOLS[currencyCode] || currencyCode || "£";
